import findLast from 'lodash/findLast';

import { MESSAGES } from '../../../constants';
import type { HeaderState } from '../../../types/appState';
import type { Agent } from '../../../types/domain';
import { getLast } from '../../../util/guards';
import { ILiveChatAgentStatus } from '../messageCreators';
import type { TRootState } from '../reducers';
import { selectItems } from './chat';

export const selectIsEnabled = (state: TRootState): boolean => {
  return state.header.isEnabled;
};

export const selectAnnouncement = (state: TRootState): HeaderState['announcement'] | undefined => {
  return state.header.announcement;
};

export const selectStatusBanner = (state: TRootState): HeaderState['statusBanner'] | undefined => {
  return state.header.statusBanner;
};

export const selectHideStatusBanner = (state: TRootState): boolean => {
  return state.header.hideStatusBanner;
};

// firstly returning agent from header.onlineAgents
// if there are no agents in header.onlineAgents, returning agent from last agent message
export const selectOnlineAgent = (state: TRootState): Agent | undefined => {
  const chatItems = selectItems(state);
  const onlineAgent = getLast(state.header.onlineAgents);

  if (onlineAgent) {
    return onlineAgent;
  }

  const lastAgentMessage = findLast(chatItems, (item) =>
    [MESSAGES.AGENT_STATUS].includes(item.type),
  ) as ILiveChatAgentStatus;
  return lastAgentMessage?.isJoined ? lastAgentMessage.agent : undefined;
};
